// extracted by mini-css-extract-plugin
export default {"zoomModal":"D2-z","image":"E2-z","button":"F2-z","isOverlayShown":"G2-z"};